webpackJsonp([143926653009679],{

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(11);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Support = function Support() {
	    return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: 'Support' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'The State of JavaScript survey is a volunteer project, but in order to make the project sustainable we\'re always looking for partners who can help support us, either financially or by helping us spread the word.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If you think you could help in any way, please don\'t hesitate to',
	                ' ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:hello@stateofjs.com' },
	                    'get in touch'
	                ),
	                '!'
	            )
	        )
	    );
	};
	
	exports.default = Support;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-support-js-d8a0366b2b344797f2bb.js